/**
 * Ð¤Ð¸Ð»ÑÑÑÑ Ð¸ ÑÑÑÐ°Ð½Ð¸ÑÐ° ÑÐ°Ð±Ð»Ð¸ÑÑ Ð² Ð°Ð´ÑÐµÑÐ½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐµ.
 *
 * ÐÐµÐ· ÑÑÐ¾Ð³Ð¾ ÑÑÐ¾Ð´ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð¸ Â«Ð½Ð°Ð·Ð°Ð´Â» Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°Ð»Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð½Ð° Ð¿ÐµÑÐ²ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ
 * Ð¿ÑÑÑÐ¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°: ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð¶Ð¸Ð»Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÑÐµÐ¹ÑÐµ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð¸ ÑÐ¼Ð¸ÑÐ°Ð»Ð¾ Ð²Ð¼ÐµÑÑÐµ Ñ Ð½ÐµÐ¹.
 * Ð¡ÑÑÐ»ÐºÑ Ñ ÑÐ¸Ð»ÑÑÑÐ¾Ð¼ Ð·Ð°Ð¾Ð´Ð½Ð¾ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÐµÑÐµÐ´Ð°ÑÑ ÐºÐ¾Ð»Ð»ÐµÐ³Ðµ.
 */

/** ÐÐ»ÑÑÐ¸, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ðµ ÑÐ²Ð»ÑÑÑÑÑ ÑÐ¸Ð»ÑÑÑÐ°Ð¼Ð¸, Ð½Ð¾ Ð¸Ñ ÑÐ¾Ð¶Ðµ Ð½Ð°Ð´Ð¾ Ð¿Ð¾Ð¼Ð½Ð¸ÑÑ. */
export const PAGE_KEY = 'page';
export const PAGE_SIZE_KEY = 'pageSize';

/**
 * @param searchParams URLSearchParams Ð¸Ð· useSearchParams
 * @param names Ð¸Ð¼ÐµÐ½Ð° ÑÐ¸Ð»ÑÑÑÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð¿Ð¾Ð½Ð¸Ð¼Ð°ÐµÑ (Ð²ÑÑ Ð»Ð¸ÑÐ½ÐµÐµ Ð¸Ð³Ð½Ð¾ÑÐ¸ÑÑÐµÐ¼,
 *   ÑÑÐ¾Ð±Ñ ÑÑÐ¶Ð¾Ð¹ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð² ÑÑÑÐ»ÐºÐµ Ð½Ðµ ÑÐµÑÐ°Ð» Ð² Ð·Ð°Ð¿ÑÐ¾Ñ Ðº Ð±ÑÐºÑ)
 */
export const parseTableQuery = (searchParams, names) => {
  const filters = {};
  names.forEach((name) => {
    const value = searchParams.get(name);
    if (value !== null && value !== '') filters[name] = value;
  });

  const page = Number(searchParams.get(PAGE_KEY));
  const pageSize = Number(searchParams.get(PAGE_SIZE_KEY));

  return {
    filters,
    page: Number.isInteger(page) && page > 0 ? page : 1,
    pageSize: Number.isInteger(pageSize) && pageSize > 0 ? pageSize : null,
  };
};

/** ÐÐ±ÑÐ°ÑÐ½Ð°Ñ Ð¾Ð¿ÐµÑÐ°ÑÐ¸Ñ: Ð¿ÑÑÑÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð² Ð°Ð´ÑÐµÑ Ð½Ðµ Ð¿Ð¸ÑÐµÐ¼, ÑÑÐ¾Ð±Ñ Ð¾Ð½ Ð½Ðµ Ð·Ð°ÑÐ°ÑÑÐ°Ð». */
export const buildTableQuery = (filters = {}, page = 1, pageSize = null) => {
  const query = {};

  Object.entries(filters).forEach(([name, value]) => {
    if (value === null || value === undefined || value === '') return;
    query[name] = String(value);
  });

  if (page > 1) query[PAGE_KEY] = String(page);
  if (pageSize) query[PAGE_SIZE_KEY] = String(pageSize);

  return query;
};
